import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, OnInit, Output } from "@angular/core";
import { FavouritesService } from "app/favourites/services/favourites.service";
import { Subscription } from "rxjs";

@Component({
  selector: "iv-live-presets",
  templateUrl: "./presets.component.html",
  styleUrls: ["./presets.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PresetsComponent implements OnInit {
  public currentPreset = 0;
  public presets = [
    "Custom",
    "Top stocks by Volume",
    "IVX Mean vs 20D HV",
    "IVX Historical Range",
    "IVX change from yesterday",
    "Volatility Skew",
  ];
  public disablePresetButtons = false;
  private sub: Subscription;

  @Output() onCurrentPresetChanged: EventEmitter<number> = new EventEmitter<number>();

  constructor(private favouritesService: FavouritesService, private readonly cd: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.sub = this.favouritesService.currentPreset.subscribe(
      (currentPreset: number) => {
        this.currentPreset = currentPreset;
        this.disablePresetButtons = false
        this.cd.detectChanges();
      }
    );
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  setCurrentPreset(i: number): void {
    if (i !== this.currentPreset) {
      this.disablePresetButtons = true
      this.onCurrentPresetChanged.emit(i)
    }
    this.cd.detectChanges();
  }
}
